import React from 'react';

import { useIconColor } from '../../../utils/hooks/useIconColor';

import SiderChevronUpIcon from '../../../resources/icons/SiderChevronUp';
import SiderChevronDownIcon from '../../../resources/icons/SiderChevronDown';
import { colorPalette } from '../../../resources/styles/colorPalette';

const DropdownArrowIcons = ({ isDropdownOpen = false }) => {
    const iconColor = useIconColor();

    return isDropdownOpen ? (
        <SiderChevronUpIcon color={colorPalette.colorPrimary} />
    ) : (
        <SiderChevronDownIcon color={iconColor} />
    );
};

export default DropdownArrowIcons;
